import React from 'react';
import { useTranslation } from 'react-i18next';
import Layout from '../components/Layout';
import Back1 from '../assets/images/back-home-1.webp';
import CoreBancarioPage from '../pages/CoreBancarioPage';
import SEO from '../components/SEO';

export const CoreBancario = () => {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;
  const isEnglish = currentLang.startsWith('en');
  const canonicalUrl = isEnglish
    ? "https://dynamicore.io/en/banking-core"
    : "https://dynamicore.io/core-bancario";

  const hreflang = [
    { url: "https://dynamicore.io/core-bancario", lang: "es" },
    { url: "https://dynamicore.io/en/banking-core", lang: "en-us" }
  ];

  return (
    <Layout backgroundimage={Back1} actionDemo={true}>
      <SEO
        title={t("Core Bancario - Plataforma Modular Digital")}
        description={t('Transforma tu empresa con un core bancario modular que digitaliza y automatiza tu operación de principio a fin. Tecnología avanzada para instituciones financieras.')}
        works={[
          t('Core Bancario'),
          t('Core Financiero'),
          t('Fintech'),
          t('Plataforma modular'),
          t('Automatización de procesos'),
          t('Digitalización financiera'),
          t('Software bancario'),
          t('Corebanking'),
          t('Tecnología financiera'),
          t('Servicios financieros digitales'),
          t('Transformación digital'),
          t('SOFIPO'),
          t('SOFOM'),
          t('CNBV'),
        ]}
        bolImage={false}
        ogImage={`dynamicore-preview.png`}
        twitterImage={`dynamicore-preview.png`}
        canonicalUrl={canonicalUrl}
        hreflang={hreflang}
      />
      <CoreBancarioPage/>
    </Layout>
  )
}
